import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initKeycloak } from './auth/keycloak';
import { initAnalytics, trackWebVital } from './analytics';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

const renderApp = (initialAuthReady, initialIsAuthenticated) => {
  root.render(
    <React.StrictMode>
      <App
        initialAuthReady={initialAuthReady}
        initialIsAuthenticated={initialIsAuthenticated}
      />
    </React.StrictMode>
  );
};

renderApp(true, false);

initAnalytics();
reportWebVitals(trackWebVital);

initKeycloak()
  .then((authenticated) => {
    console.info('[auth] Keycloak authenticated:', authenticated);
  })
  .catch((err) => {
    console.warn('[auth] Keycloak background bootstrap failed; continuing as guest', err);
  });
